import type { FirebaseApp } from "firebase/app";
import type { Auth } from "firebase/auth";

// Keep our initialized instance across Fast Refresh. Native persistence creates
// a new class per factory call, so repeated initializeAuth options can conflict.
export function initializeAuthOnce(app: FirebaseApp, initialize: () => Auth): Auth {
  const runtime = globalThis as typeof globalThis & {
    __classtiAuthInstances?: WeakMap<FirebaseApp, Auth>;
  };
  const instances = runtime.__classtiAuthInstances ??= new WeakMap<FirebaseApp, Auth>();
  const existing = instances.get(app);
  if (existing) return existing;
  const auth = initialize();
  instances.set(app, auth);
  return auth;
}
